import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook } from '@fortawesome/free-solid-svg-icons';
import api from '../utils/api';
import EmployeeMultiSelect from './EmployeeMultiSelect';

/**
 * The "Vendors" card on the task forms (guest role, Phase 3).
 *
 * Fed from the Vendors directory, which the server already narrows to the
 * vendors this person may assign: every vendor for Admin, HR and managers,
 * otherwise the ones they work with. Renders nothing for somebody with none,
 * so the form is unchanged for them.
 */
const VendorSection = ({ selected, onChange, keep = [] }) => {
    const [vendors, setVendors] = useState(null);

    useEffect(() => {
        api.get('/external-users')
            .then((res) => setVendors((res.data || []).map((v) => ({
                _id: v._id,
                name: v.name,
                profilePic: v.profilePic,
                role: v.company || 'Guest'
            }))))
            .catch(() => setVendors([]));
    }, []);

    if (!vendors) return null;

    // Vendors already on the task stay pickable even if no longer listed for
    // this person, so an edit never silently drops them.
    const listed = new Set(vendors.map((v) => v._id));
    const options = [...vendors, ...keep.filter((v) => !listed.has(v._id))];
    if (!options.length) return null;

    return (
        <section className="task-form-card">
            <div className="expense-section-title">
                <FontAwesomeIcon icon={faAddressBook} /> Guests
                {selected.length > 0 && <span className="task-count-pill">{selected.length} selected</span>}
            </div>
            <EmployeeMultiSelect
                employees={options}
                selected={selected}
                onChange={onChange}
                placeholder="Search and select guests..."
                emptyText="No guests yet."
            />
            <small className="task-hint">
                Guests work on the task like any assignee: they see it in their guest space, update its status
                and join its discussion. They are emailed when added.
            </small>
        </section>
    );
};

export default VendorSection;
